export default {
  "activityBonusRecord.title": "Activity Bonus Records",
  "activityBonusRecord.column.no": "#NO",
  "activityBonusRecord.column.userNo": "User No",
  "activityBonusRecord.column.eventId": "Event ID",
  "activityBonusRecord.column.channel": "Channel",
  "activityBonusRecord.column.eventDetail": "Event Detail",
  "activityBonusRecord.column.eventType": "Event Type",
  "activityBonusRecord.column.createTime": "Create Time",
  "activityBonusRecord.search.userNo": "User No",
  "activityBonusRecord.search.eventId": "Event ID",
  "activityBonusRecord.search.channel": "Channel",
  "activityBonusRecord.search.eventType": "Event Type",
  "activityBonusRecord.tooltip.copy.userNo": "Copy User No: {text}",
  "activityBonusRecord.tooltip.copy.eventId": "Copy Event ID: {text}",
  "activityBonusRecord.tooltip.showUserDetails": "Show User Details",
  "activityBonusRecord.copy.success": "Copied to clipboard",
};